import * as React from 'react';
import FormHeading from '@ane/ui-components/lib/components/FormHeading/FormHeading';
import { TagPickerField, TextField } from '@ane/ui-components/lib/components/FormikFormFields';
import FormSection from '@ane/ui-components/lib/components/FormSection/FormSection';
import { StepContainer } from '@ane/ui-components/lib/components/Layout/StepContainer/StepContainer';
import { CreateStepTitle } from '../CreateWizard/CreateSteps';
import DataSourceResource from '../../../../DataSource.resource';
import { DataSourceTypes } from '../../../../constants/DataSource.constants';
import Logger from '@ane/core/lib/services/logging/Logger';
import { LearnMoreLink } from '@ane/ui-components/lib/components/Link/LearnMoreLink';
export function DataLinkInfoComponent(props) {
    const pickerSuggestionsProps = {
        suggestionsContainerAriaLabel: 'Suggested sample data sources',
        loadingText: 'Search...',
        noResultsFoundText: '',
    };
    const onSampleDatasourceFilterChanged = (filter, selectedItems) => {
        if (!!filter) {
            const searchResult = DataSourceResource.getDataSourceList(props.workspaceId, filter, DataSourceTypes.Sample);
            const convertedReuslt = searchResult
                .then((r) => {
                if (!!r.getSuccessData().Items && r.getSuccessData().Items.length > 0) {
                    return r
                        .getSuccessData()
                        .Items.filter((item) => {
                        return item.Name.toLowerCase().indexOf(filter.toLowerCase()) >= 0;
                    })
                        .map((item) => {
                        return {
                            key: item.Name,
                            name: item.Name,
                        };
                    });
                }
                else {
                    pickerSuggestionsProps.noResultsFoundText = 'No result found';
                    return [];
                }
            })
                .catch((e) => {
                Logger.error('Error while fetching sample data sources', e);
            });
            return convertedReuslt;
        }
        else {
            pickerSuggestionsProps.noResultsFoundText = 'No result found';
            return [];
        }
    };
    return (React.createElement(StepContainer, null,
        React.createElement(FormHeading, { pageTitle: CreateStepTitle.Links },
            "Link a sample data for quick metric validation from this main data source.",
            ' ',
            React.createElement(LearnMoreLink, { "aria-label": "Learn more", href: 'https://aka.ms/exp/docs/dsmsoverview' })),
        React.createElement(FormSection, null,
            React.createElement(TagPickerField, { name: 'linkedSampleDataSource', label: "Data source to link", showSuggestions: true, labelProps: {
                    iconProps: {
                        calloutProps: {
                            content: 'Enter name or search for sample data source. The linked sample data source will be used for quick metric preview.',
                        },
                    },
                }, tagPickerProps: {
                    ariaLabel: 'Sample Datasource TagPicker',
                    removeButtonAriaLabel: 'Remove Selected Sample datasource',
                    itemLimit: 1,
                    selectedItems: props.formikProps.values.linkedSampleDataSource
                        ? props.formikProps.values.linkedSampleDataSource.map((item) => {
                            return {
                                key: item,
                                name: item,
                            };
                        })
                        : [],
                    onResolveSuggestions: onSampleDatasourceFilterChanged,
                    resolveDelay: 300,
                    pickerSuggestionsProps: pickerSuggestionsProps,
                }, required: false, disabled: !!props.isReadOnly }),
            React.createElement(TextField, { name: 'linkComment', innerTextFieldProps: {
                    ariaLabel: 'Link Comment',
                    label: 'Comment',
                    required: false,
                    disabled: !!props.isReadOnly,
                    multiline: true,
                } }))));
}
export default DataLinkInfoComponent;

//# sourceMappingURL=DataLinkInfoComponent.js.map
